import { createAction, makeActionTrackable } from '@lingoda/core';
import type { LearningUnit } from './models';

export const addLearningUnits = createAction<LearningUnit[]>('learning-units/ADD_LEARNING_UNITS');

export const fetchLearningUnits = makeActionTrackable(
    createAction<number[]>('learning-units/FETCH_LEARNING_UNITS'),
);
